import styled from "styled-components";
import { breakpoint } from "@m/alchemy-theme";
const getWidthPercentage = (numerator) => `${((numerator / 12) * 100).toFixed(10)}%`;
const flexWidth = (w) => `flex-basis: ${w}; max-width: ${w};`;
const flexOffset = (w) => `margin-left: ${w};`;
const insertMediaQueries = (allBreakpoints, span, offset, theme) => {
    // with context
    if (allBreakpoints) {
        return Object.entries(allBreakpoints)
            .sort((a, b) => a[1] - b[1])
            .map((entry) => {
            const key = entry[0];
            return span !== undefined || offset !== undefined
                ? `@media all and (min-width: ${allBreakpoints[key]}px) {
              ${typeof span === "object" && span !== null && span[key]
                    ? flexWidth(getWidthPercentage(span[key] || 0))
                    : ""};
              ${typeof offset === "object" && offset !== null && offset[key]
                    ? flexOffset(getWidthPercentage(offset[key] || 0))
                    : ""}
            }`
                : "";
        });
    }
    // without context
    if (typeof span === "object" || typeof offset === "object") {
        return `@media all and (min-width: ${breakpoint("medium")({
            theme
        })}px) {
      ${span && typeof span === "object" && span.medium ? flexWidth(getWidthPercentage(span.medium)) : ""}
      ${offset && typeof offset === "object" && offset.medium ? flexOffset(getWidthPercentage(offset.medium)) : ""}
    }
    @media all and (min-width: ${breakpoint("large")({
            theme
        })}px) {
      ${span && typeof span === "object" && span.large ? flexWidth(getWidthPercentage(span.large)) : ""}
      ${offset && typeof offset === "object" && offset.large ? flexOffset(getWidthPercentage(offset.large)) : ""}
    }`;
    }
    return "";
};
export const Col = styled.div `
  box-sizing: border-box;
  flex: 0 0 auto;
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
  ${({ isReversed }) => (isReversed ? "flex-direction: column-reverse;" : "")};
  ${({ span }) => {
    if (typeof span === "number") {
        return flexWidth(getWidthPercentage(span));
    }
    return span && span.small ? flexWidth(getWidthPercentage(span.small)) : flexWidth(getWidthPercentage(12));
}};
  ${({ offset }) => {
    if (typeof offset === "number") {
        return flexOffset(getWidthPercentage(offset));
    }
    return offset && offset.small ? flexOffset(getWidthPercentage(offset.small)) : flexOffset(0);
}};
  ${({ breakpoints, span, offset, theme }) => (span ? insertMediaQueries(breakpoints, span, offset, theme) : "")};
`;
export const sharedDefaultValues = {
    children: null,
    span: 12,
    offset: 0,
    isReversed: false
};
Col.defaultProps = sharedDefaultValues;
